import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translation.json";
import fr from "./locales/fr/translation.json";

// Check for language preference in both storage formats
let initialLang = "en";

// First try the new format (JSON object with language preference)
try {
  const storedPreference = localStorage.getItem("language_preference");
  if (storedPreference) {
    const preference = JSON.parse(storedPreference);
    if (preference && (preference.language === "en" || preference.language === "fr")) {
      initialLang = preference.language;
    }
  }
} catch (e) {
  console.error("Error reading language preference:", e);
}

// Fallback to the old format if needed
if (initialLang === "en") {
  const storedLang = localStorage.getItem("lang");
  if (storedLang === "en" || storedLang === "fr") {
    initialLang = storedLang;
  }
}

i18n
  .use(initReactI18next)
  .init({
    lng: initialLang,
    fallbackLng: "en",
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    interpolation: { escapeValue: false },
  });

export default i18n;